import useSocket from './use-socket.js';
import useDevices from './use-devices.js';
import {useEffect} from 'react';
import {filter, mergeAll, tap} from 'rxjs/operators';

export const useSubjectsRealtimeUpdates = () => {
  const {
    devices: devicesObservable,
    devicesRemoved: devicesRemovedObservable,
    positions: positionsObservable,
  } = useSocket();
  const {devices: deviceStore} = useDevices();


  // devices
  useEffect(() => {
    const devicesSubscription$ = devicesObservable.pipe(
      filter(Array.isArray),
      mergeAll(),
      tap((device) => {
        deviceStore.updateDevice(device);
      }),
    ).subscribe({
      error: (err) => console.error('devices realtime update error', err),
    });

    return () => {
      if (devicesSubscription$) {
        devicesSubscription$.unsubscribe();
      }
    };
  }, [devicesObservable]);


  // devicesRemoved
  useEffect(() => {
    const devicesRemovedSubscription$ = devicesRemovedObservable.pipe(
      filter(Array.isArray),
      mergeAll(),
      tap((deviceId) => {
        deviceStore.removeDevice(deviceId);
      }),
    ).subscribe({
      error: (err) => console.error('devicesRemoved realtime update error', err),
    });

    return () => {
      if (devicesRemovedSubscription$) {
        devicesRemovedSubscription$.unsubscribe();
      }
    };
  }, [devicesRemovedObservable]);


  // positions
  useEffect(() => {
    const positionsSubscription$ = positionsObservable.pipe(
      tap((positions) => {
        deviceStore.updatePositions(positions);
      }),
    ).subscribe();

    return () => {
      if (positionsSubscription$) {
        positionsSubscription$.unsubscribe();
      }
    };
  }, [positionsObservable]);
};
